import {useEffect, useState} from 'react';
import './Form.css';
import avatar from '../../assets/logo-beta-1.png';
import img_1 from '../../assets/img_1.png';
import img_2 from '../../assets/img_2.png';
import fundo from '../../assets/fundo.jpg';
import { GiCardboardBoxClosed, GiCat,GiNotebook,GiStoneTower, GiTotem, GiFiles } from 'react-icons/gi';
import { Badge } from 'antd';

import InputMask from 'react-input-mask';
import api from '../../services/api';

const PhoneInput = ({ className, ...props }) => {
  const [mask, setMask] = useState("(99) 99999-9999");

  return (
    <InputMask
      {...props}
      mask={mask}
      onBlur={e => {
        if (e.target.value.replace("_", "").length === 14) {
          setMask("(99) 9999-9999");
        }
      }}
      onFocus={e => {
        if (e.target.value.replace("_", "").length === 14) {
          setMask("(99) 99999-9999");
        }
      }}
    >
      {inputProps => <input {...inputProps} type="tel" />}
    </InputMask>
  );
};

export default function Main({children, name}){

  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [hwidth, setHwidth] = useState(window.innerWidth);
  const [contatoPage, setContatoPage] = useState(1);
  const [isWhats, setIsWhats] = useState(false);

  const [info, setInfo] = useState("");
  

  useEffect(() => {
      function handleResize() {
          setHwidth(window.innerWidth);
      }
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [hwidth]);

  useEffect(() => {
      let temp_hwidth = hwidth;
      if( temp_hwidth < 620) { 
          if( !isMobile ){ setIsMobile(true) }   
      }else{ 
          if(isMobile){ setIsMobile(false) }           

      }
     // toast.success(temp_hwidth)
  }, [hwidth]);

  function apenasNumeros(_string)
  {                                          
      if(_string.match(/^[0-9\-\_\(\)\" "]+$/) != null){
          return true;
      } else {
          return false;
      }
  }   
  
  
  useEffect(() => { 
    if(email.length >= 2 && apenasNumeros(email) == true ){
      if(isWhats == false){
        setIsWhats(true);
      }
    }else{
      if(isWhats == true){
        setIsWhats(false);
      }
    }
  },[email]);


function enviarForm(estado=""){
  setContatoPage(4)
  envia(estado);
}

  function contato(id="", autoFocus=false){
    

    return(<>
      <div className="fundo" > 
          <div className="info-box" style={{width:"auto", minWidth:"410px", height:"auto"}}>
            <div className="col_a">
            { contatoPage <= 1 && <>
              <img width="64" height="64" 
                  src="https://img.icons8.com/external-nawicon-outline-color-nawicon/64/external-Agreement-business-management-nawicon-outline-color-nawicon.png" />
                  </>}
                  { contatoPage == 2 && <>
                    <img width="64" height="64" src="https://img.icons8.com/fluency/48/company.png" alt="company"/>
                  </>}
            </div>
            <div className="col_full">
              <div className="sibe-content-title" style={{width:"auto", textAlign:"center"}}>
                { contatoPage == 1 ? <>
                <p className="title-bar-texto" style={{color:"black", fontSize:"16px"}}>Nós entramos em contato com você!</p>   
                <div className="edit-mail">
                  {  email.length <= 1 ? <>
                    <img width="30" height="30" src="https://img.icons8.com/color/48/chat--v1.png" alt="chat--v1"/>
                   </> :
                  email.length >= 2 && apenasNumeros(email) == true ? <>
                    <img width="30" height="30" src="https://img.icons8.com/color/48/whatsapp--v1.png" style={{marginTop:"-1px"}}/>
                  </>:<>
                    <img width="28" height="28" src="https://img.icons8.com/fluency/48/mail.png" style={{marginLeft:"2px"}}/>
                  </> }

                  { isWhats ? <>
                    <PhoneInput name={id} id={id} style={{textAlign:"center", border:"none", width:"100%"}} value={email} onChange={e=>{ setEmail(e.target.value) }}  autoFocus={autoFocus} />
                  </>: <>
                  <input name={id} id={id} className="edit-mail-input" style={{textAlign:"center"}} 
                        value={email} onChange={e=>{ setEmail(e.target.value) }} placeholder='informe seu WhatsApp ou Email' />
                  </>}

                  
                 
                  <button className='btn-ok' onClick={()=>{ if(email.length > 5){ setContatoPage(2)}}} >OK</button>
                </div>
                </> : contatoPage == 2 ? <>
                  <p className="title-bar-texto" style={{color:"black", fontSize:"16px"}}>Qual o nome da sua empresa?</p>   
                  <div className="edit-mail">
                    <input className="edit-mail-input" style={{textAlign:"center", margin:"5px"}}
                          value={nome} onChange={e=>{ setNome(e.target.value) }} placeholder='nome da empresa' />

                  <button className='btn-ok' onClick={()=>{if(nome.length > 2){ setContatoPage(3); }}} >OK</button>
                </div>
                </> :  contatoPage == 3 ? <>
                <p className="title-bar-texto" style={{color:"black", fontSize:"16px"}}>Para conluir, clique no estado de atuação.</p>   
                <div className="seletor-estado">               
                  <button className="btn-estado" onClick={()=>{enviarForm("AC")}} >AC</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("AL")}} >AL</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("AP")}} >AP</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("AM")}} >AM</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("BA")}} >BA</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("CE")}} >CE</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("DF")}} >DF</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("ES")}} >ES</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("GO")}} >GO</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("MA")}} >MA</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("MT")}} >MT</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("MS")}} >MS</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("MG")}} >MG</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("PA")}} >PA</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("PB")}} >PB</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("PR")}} >PR</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("PI")}} >PI</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("RJ")}} >RJ</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("RN")}} >RN</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("RS")}} >RS</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("RO")}} >RO</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("RR")}} >RR</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("SC")}} >SC</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("SP")}} >SP</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("SE")}} >SE</button>
                  <button className="btn-estado" onClick={()=>{enviarForm("TO")}} >TO</button>
                </div>
                </> : <div style={{height:"100px", width:"420px", display:"flex", flexDirection:"column", justifyContent:'center',alignItems:"center", gap:"20px"}}>
                  
                    <p>Obrigado, em breve entraremos em contato.</p>
                    <img width="48" height="48" src="https://img.icons8.com/color/48/checked--v1.png" alt="checked--v1"/>
                </div>
                
              }
              
              </div>
            </div>
          </div>    
        </div>
    </>)
  }

  function itemT(nome, cor){
    return(<>
      <div style={{width:"auto", maxHeight:"20px", display:"flex", borderRadius:"10px", padding:"11px",
                   justifyContent:"center", alignItems:"center", backgroundColor:cor, color:"white"}}>
        {nome}
      </div>
    </>)
  }

  async function envia(uf){
    try {                
      const resp = await api.post(`/beitecForm`, {
        code:String("SITE_MAIN"),
        form:String("A00001"),
        nome:String(nome),
        email:String(email),
        fone:String(""),
        whats:String(email),
        aux_a:String('concordo'),
        aux_b:String(uf),
      });   
      //alert(JSON.stringify(resp.data));
      if((resp.data.message) == "OK"){
          return;
      }
  }catch(e){
     // toast.error('Erro.. '+e);
  }
}


  return(
    <>
       
        <div className="title-bar">
          {/*  <div className="sibe-content-avatar"><img src={avatar}  ></img>  </div> */}
          <div className="sibe-content-title">
            <p className="title-bar-texto">BEITEC</p>   
            <p className="title-bar-sub">software + negócios + gestão</p>   
          </div>
        </div>
        <div style={{zIndex:-1, backgroundImage : `url(${fundo})`, backgroundColor:"black", backgroundSize: "cover", 
                      position:"absolute", height:"calc(100% - 50px)", width:"100%", opacity:"0.25", }}/>
        <div className="app-content" >
        



         { contato("cnt-01", true) }
         </div>
    </>
    )
}
